var React = require('react');

function TransferTo (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25.5","cy":"25","r":"25","fill":"#FFCC00","key":0}),React.createElement("path",{"d":"M33 24.188C33 24.188 32.057 24.723 30 24.723M18 24.723C18 24.723 18.942 24.188 21 24.188M15.5 30.5V19.4C15.5 19.4 16.833 18 20.833 18C24.833 18 25.899 20 30.166 20C31.973 19.952 33.765 19.672 35.5 19.167V30.5C35.5 30.5 34.033 31.334 30.833 31.334C27.633 31.334 25.1 29.334 21.5 29.334C19.44 29.305 17.397 29.702 15.5 30.5ZM27.467 24.667C27.667 25.767 26.928 26.667 25.85 26.667C24.771 26.667 23.732 25.767 23.532 24.667C23.333 23.567 24.071 22.667 25.15 22.667C26.229 22.667 27.287 23.547 27.467 24.667Z","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

TransferTo.defaultProps = {"width":"51","height":"50","viewBox":"0 0 51 50","fill":"none"};

module.exports = TransferTo;

TransferTo.default = TransferTo;
